import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/commande-fournisseur.service';



export const listCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listFbCmd = createAsyncThunk(
    "CmdFournisseur/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAllOpenFB(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listOpenCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-viewAllOpen",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAllOpen(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const uploadPhotoCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-uploadPhoto",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.uploadPhoto(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createManyCQCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-createManyCQ",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createManyCQ(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const updateManyCQCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-updateManyCQ",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateManyCQ(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCmdMultiStatus = createAsyncThunk(
    "CmdFournisseur/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateMultiStatus(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const FBupdateCmdMultiStatus = createAsyncThunk(
    "CmdFournisseur/adm-updateMultiStatusFB",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateMultiStatusFB(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateManyCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-updateMany",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateMany(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const FBupdateManyCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-updateManyFB",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateManyFB(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const findAllCmdByFbStatus = createAsyncThunk(
    "CmdFournisseur/adm-findAllByFbStatus",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.findAllByFbStatus(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterAllCmdFournisseur = createAsyncThunk(
    "CmdFournisseur/adm-filterAll",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const searchCmdPublicByRef = createAsyncThunk(
    "CmdFournisseur/adm-search",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.searchPublicByRef(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listCmdExpedition = createAsyncThunk(
    "CmdFournisseur/adm-listCmdExpedition",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAllExpedition(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)







const initialState = {
    loading: false,
    error: '',
    sel_CmdFournisseur: null
}

const CmdFournisseurSlice = createSlice({
    name: "CmdFournisseur",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = CmdFournisseurSlice;
export const { clear } = CmdFournisseurSlice.actions;
export default reducer;